import { OFFERS } from "../constants/constantApi"
import { getDomain } from "./getTld"

/** Фолбэк, если VITE_OFFERWALL_URL не задан или невалиден. */
export const DEFAULT_OFFERWALL_ORIGIN = "https://houston-frontend.leadsor.com"

/**
 * Домен офферволла: VITE_OFFERWALL_URL (например https://loans.pujckafon.cz),
 * иначе https://houston-frontend.leadsor.com.
 * На этом домене путь /offers проксируется во frontend-machine (как /go).
 */
export function getOfferwallOrigin(): string {
  const configured = process.env.VITE_OFFERWALL_URL?.trim()
  if (configured) {
    try {
      return new URL(/^https?:\/\//i.test(configured) ? configured : `https://${configured}`).origin
    } catch {
      console.warn(
        "[offerwall] VITE_OFFERWALL_URL is not a valid URL, falling back to houston-frontend.leadsor.com",
        configured
      )
    }
  }
  return DEFAULT_OFFERWALL_ORIGIN
}

/** Адрес офферволла: его домен + /offers, с регионом и параметрами визита. */
export function getOfferwallUrl(search: string = window.location.search): string {
  const params = new URLSearchParams(search)
  params.set("region", getDomain())
  return `${getOfferwallOrigin()}/${OFFERS}?${params.toString()}`
}

/** Полный переход (не внутри SPA): страницу отдаёт frontend-machine. */
export function redirectToOfferwall(search?: string): void {
  window.location.replace(getOfferwallUrl(search))
}
